import { useState, useEffect, useRef } from "react";
import "../../pages/SalesMasterPages/ViewLeadDetail/ViewLeadDetail.css";
import React from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import Wrapper from "../../components/UI/Wrapper";
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

const ViewTaskAssignedDetails = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const location = useLocation();
  const [leadUpdate, setLeadUpdate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [decryptionError, setDecryptionError] = useState(false);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const userName = localStorage.getItem("name");
  const [assignToResponse, setAssignToResponse] = useState([]);
  //----------------------------------------------//
  const baseAPI = process.env.REACT_APP_API_URL;

  const fileInputRef = useRef(null);

  const searchParams = new URLSearchParams(location.search);
  const TaskID = searchParams.get("task_id");

  const assigned = searchParams.get("assigned");
  const By_Me = assigned === "by_me";
  const To_Me = assigned === "to_me";
  const [taskInfoResponse, settaskInfoResponse] = useState([]);
  const [remarksList, setRemarksList] = useState([]);

  const [firstItem, setFirstItem] = useState({
    task_id: "",
    created_on: "",
    last_updated_date: "",
    task_start_date: "",
    due_date: "",
    complete_date: "",
    task_category: "",
    task_title: "",
    task_description: "",
    department: "",
    frequency: "",
    AssignedBy: "",
    AssignedTo: "",
    task_status: "",
    task_priority: "",
    progress_per: "",
    time_log_in_days: "",
    task_source: "",
    task_dependency: "",
    task_outcome: "",
    escalation_level: "",
  });
  const canShow = isAdmin || (firstItem && firstItem.name === userName);

  useEffect(() => {
    setFirstItem((prevItem) => ({
      ...prevItem,
      task_id: TaskID,
    }));

    getDocument(TaskID);
    getEmployeeByDepartment();
  }, []);

  async function getDocument(TaskID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.get(
          `${baseAPI}userget/GetTaskIndividualDetail?task_id=` + TaskID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response?.data?.data?.TaskInfo) {
          settaskInfoResponse(response.data.data.TaskInfo[0]);
          setFirstItem(response.data.data.TaskInfo[0]);
          setRemarksList(response.data.data.RemarksInfo || []);
        } else {
          return null;
        }
      } catch (error) {
        console.error("Error fetching user detail:", error);
        return null;
      }
    }
    return null;
  }

  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleClick = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  const handleSubmit = async () => {
   
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}userpost/InsertTaskAssignedByMe`,
        firstItem, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      window.location.reload();
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const gradientColors = ["#F15843", "#A3519F", "#5B489D"];

  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />
        <div className="container-fluid container-viewLeadDetails">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <b> View Task Assigned Details </b> | <HomeOutlinedIcon /> &gt;
                <a style={{ cursor: "pointer" }}>Task List </a>
                <span style={{ fontSize: "20px" }}>&gt; Task Details</span>
              </h1>
            </div>
          </div>
          <Wrapper className="LeadDetails">
            {/* ----------------------------------Quotation builder-------------------------------- */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ marginTop: "-1rem" }}>
                {canShow && (
                  <button
                    className={
                      isEditMode
                        ? "btn btn-primary edit-Button-on"
                        : "btn btn-primary edit-Button-off"
                    }
                    onClick={toggleEditMode}
                  >
                    EDIT
                  </button>
                )}
              </div>
            </div>
          </Wrapper>

          <br />

          <div>
            {/* ------------------------task deatil--------------------- */}
            <Wrapper className="LeadDetails">
              {successMessage && (
                <div style={{ color: "green" }}>{successMessage}</div>
              )}
              {isEditMode ? (
                <>
                  {/* ----------Edit mode--------------- */}
                  <div className="viewLeadDetails-form">
                    <table
                      style={{
                        width: "100%",
                        color: "#6A6A6A",
                        borderRadius: "5px",
                      }}
                    >
                      <tr className="viewLeadDetailsHeading">
                        <th
                          colSpan={4}
                          style={{
                            background: "#5B489D",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          <span style={{ fontSize: "18px" }}>
                            {" "}
                            Task Detail{" "}
                          </span>
                        </th>
                      </tr>
                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Task ID</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_id}</span>
                        </td>
                        <th>
                          <span>Created On</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.created_on}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Start Date</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_start_date}</span>
                        </td>
                        <th>
                          <span>Due Date</span>
                        </th>
                        <td>
                          <input
                            className="form-control"
                            type="date"
                            name="due_date"
                            value={firstItem.due_date}
                            placeholder="Please Enter*"
                            onChange={handleChange1}
                          />
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Last Updated</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.last_updated_date}</span>
                        </td>
                        <th>
                          <span>Completed Date</span>
                        </th>
                        <td>
                          <input
                            className="form-control"
                            type="date"
                            name="complete_date"
                            value={firstItem.complete_date}
                            placeholder="Please Enter*"
                            onChange={handleChange1}
                          />
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Task Title</span>
                        </th>
                        <td>
                          {By_Me ? (
                            <input
                              type="text"
                              className="form-control"
                              name="task_title"
                              value={firstItem.task_title}
                              onChange={handleChange1}
                            />
                          ) : (
                            <span>{taskInfoResponse.task_title}</span>
                          )}
                        </td>
                        <th>
                          <span>Task Description</span>
                        </th>
                        <td>
                          {By_Me ? (
                            <input
                              type="text"
                              className="form-control"
                              name="task_description"
                              value={firstItem.task_description}
                              onChange={handleChange1}
                            />
                          ) : (
                            <span>{taskInfoResponse.task_description}</span>
                          )}
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Task Category</span>
                        </th>
                        <td>
                          <select
                            className="form-control"
                            name="task_category"
                            value={firstItem.task_category}
                            onChange={handleChange1}
                          >
                            <option value="">Select an option</option>
                            <option value="Internal">Internal</option>
                            <option value="Client-Related">
                              Client-Related
                            </option>
                            <option value="Follow-up">Follow-up</option>
                            <option value="Report / Documentation">
                              Report / Documentation
                            </option>
                            <option value="Review & Approval">
                              Review & Approval
                            </option>
                            <option value="Data Entry">Data Entry</option>
                            <option value="Development / Tech">
                              Development / Tech
                            </option>
                            <option value="Audit / Compliance">
                              Audit / Compliance
                            </option>
                          </select>
                        </td>

                        <th>
                          <span>Department</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.department}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Assigned By</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.AssignedByName}</span>
                        </td>

                        <th>
                          <span>Assigned To</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.AssignedToName}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Frequency</span>
                        </th>
                        <td>
                          <select
                            className="form-control"
                            name="frequency"
                            value={firstItem.frequency}
                            onChange={handleChange1}
                          >
                            <option value="">Select an option</option>
                            <option value="One Time">One Time</option>
                            <option value="Daily">Daily</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Annually">Annually</option>
                          </select>
                        </td>
                        <th>
                          <span>Status</span>
                        </th>
                        <td>
                          {By_Me ? (
                            <span>{taskInfoResponse.task_status}</span>
                          ) : (
                            <select
                              className="form-control"
                              name="task_status"
                              value={firstItem.task_status}
                              onChange={handleChange1}
                            >
                              <option value="">Select an option</option>
                              <option value="In Progress">In Progress</option>
                              <option value="On Hold">On Hold</option>
                              <option value="Not Started">Not Started</option>
                              <option value="Completed">Completed</option>
                              <option value="Blocked">Blocked</option>
                              <option value="Deferred">Deferred</option>
                              <option value="Cancelled">Cancelled</option>
                            </select>
                          )}
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Priority</span>
                        </th>
                        <td>
                          <select
                            className="form-control"
                            name="task_priority"
                            value={firstItem.task_priority}
                            onChange={handleChange1}
                          >
                            <option value="">Select an option</option>
                            <option value="Critical">Critical</option>
                            <option value="High">High</option>
                            <option value="Medium">Medium</option>
                            <option value="Low">Low</option>
                          </select>
                        </td>
                        <th>
                          {" "}
                          <span>Progress Percentage</span>
                        </th>
                        <td>
                          <input
                            type="number"
                            name="progress_per"
                            value={firstItem.progress_per}
                            className="form-control"
                            onChange={handleChange1}
                          />
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Time Log in Days</span>
                        </th>
                        <td>
                          <input
                            type="number"
                            name="time_log_in_days"
                            value={firstItem.time_log_in_days}
                            className="form-control"
                            onChange={handleChange1}
                          />
                        </td>
                        <th>
                          <span>Task Source</span>{" "}
                        </th>
                        <td>
                          <select
                            className="form-control"
                            name="task_source"
                            value={firstItem.task_source}
                            onChange={handleChange1}
                          >
                            <option value="">Select an option</option>
                            <option value="Internal Meeting">
                              Internal Meeting
                            </option>
                            <option value="Client Request">
                              Client Request
                            </option>
                            <option value="Email">Email</option>
                            <option value="WhatsApp / Phone Call">
                              WhatsApp / Phone Call
                            </option>
                            <option value="Audit Observation">
                              Audit Observation
                            </option>
                            <option value="SOP / Checklist">
                              SOP / Checklist
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Dependency</span>
                        </th>
                        <td>
                          <input
                            type="text"
                            name="task_dependency"
                            value={firstItem.task_dependency}
                            className="form-control"
                            onChange={handleChange1}
                          />
                        </td>
                        <th>
                          <span>Task Outcome</span>
                        </th>
                        <td>
                          <select
                            className="form-control"
                            name="task_outcome"
                            value={firstItem.task_outcome}
                            onChange={handleChange1}
                          >
                            <option value="">Select an option</option>
                            <option value="Delivered">Delivered</option>
                            <option value="Delayed">Delayed</option>
                            <option value="Escalated">Escalated</option>
                            <option value="Under Review">Under Review</option>
                            <option value="Needs Rework">Needs Rework</option>
                          </select>
                        </td>
                      </tr>
                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Escalation Level</span>
                        </th>
                        <td>
                          <select
                            className="form-control"
                            name="escalation_level"
                            value={firstItem.escalation_level}
                            onChange={handleChange1}
                          >
                            <option value="">Select an option</option>
                            <option value="None">None</option>
                            <option value="Team Lead">Team Lead</option>
                            <option value="Department Head">
                              Department Head
                            </option>
                            <option value="Management">Management</option>
                          </select>
                        </td>
                        <th>
                          <span>Remark</span>
                        </th>
                        <td>
                          <input
                            type="text"
                            name="remark"
                            value={firstItem.remark}
                            className="form-control"
                            onChange={handleChange1}
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                  <br />
                </>
              ) : (
                <>
                  {/* ----------view mode--------------- */}

                  <div className="viewLeadDetails-form">
                    <table
                      style={{
                        width: "100%",
                        color: "#6A6A6A",
                        borderRadius: "5px",
                      }}
                    >
                      <tr className="viewLeadDetailsHeading">
                        <th
                          colSpan={4}
                          style={{
                            background: "#5B489D",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          <span style={{ fontSize: "18px" }}>
                            {" "}
                            Task Detail{" "}
                          </span>
                        </th>
                      </tr>
                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Task ID</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_id}</span>
                        </td>
                        <th>
                          <span>Created On</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.created_on}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Start Date</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_start_date}</span>
                        </td>
                        <th>
                          <span>Due Date</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.due_date}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Last Updated</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.last_updated_date}</span>
                        </td>
                        <th>
                          <span>Completed Date</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.complete_date}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Task Title</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_title}</span>
                        </td>
                        <th>
                          <span>Task Description</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_description}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Task Category</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_category}</span>
                        </td>

                        <th>
                          <span>Department</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.department}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Assigned By</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.AssignedByName}</span>
                        </td>

                        <th>
                          <span>Assigned To</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.AssignedToName}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Frequency</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.frequency}</span>
                        </td>
                        <th>
                          <span>Status</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_status}</span>
                        </td>
                      </tr>

                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Priority</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_priority}</span>
                        </td>
                        <th>
                          {" "}
                          <span>Progress Percentage</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.progress_per}</span>
                        </td>
                      </tr>
                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Time Log in Days</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.time_log_in_days}</span>
                        </td>
                        <th>
                          <span>Task Source</span>{" "}
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_source}</span>
                        </td>
                      </tr>
                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Dependency</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_dependency}</span>
                        </td>
                        <th>
                          <span>Task Outcome</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.task_outcome}</span>
                        </td>
                      </tr>
                      <tr className="viewLeadDetailsHeading">
                        <th>
                          <span>Escalation Level</span>
                        </th>
                        <td>
                          <span>{taskInfoResponse.escalation_level}</span>
                        </td>
                        <th>
                          <span></span>
                        </th>
                        <td>
                          <span></span>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <br />
                </>
              )}
            </Wrapper>
            <br />
            <form>
              <Wrapper className="LeadDetails">
                {/* ----------------------------------Update Lead Information-------------------------------------- */}

                <br />
                <h3
                  style={{
                    marginTop: "1rem",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  Lead Timeline
                </h3>
                <div
                  style={{
                    width: "100%",
                    maxHeight: "300px",
                    overflowY: "scroll",
                    alignItems: "center",
                  }}
                >
                  <table
                    className="customerDetailsTable"
                    style={{ width: "99%", marginLeft: "5px" }}
                  >
                    {remarksList.map((remark, index) => (
                      <div
                        className="wrapper undefined"
                        style={{ width: "100%" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "1rem",
                            padding: "1rem",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <h3 className="card-title">
                              <b>Remark {remarksList.length - index} </b>{" "}
                            </h3>
                            
                          </div>

                          <div
                            className="row"
                            style={{ padding: "11px 0 0 0", border: "none" }}
                          >
                            <div className="col-12">
                              <div
                                className="card"
                                style={{
                                  width: "100%",
                                  boeder: "none",
                                  background: "none",
                                }}
                              >
                                <div className="card-body">
                                  <p
                                    className="card-text"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                   {remark.Name} - {remark.remark}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </table>
                </div>
              </Wrapper>
              <br />

              <br />
              {canShow && (
                <div
                  id="divSubmit"
                  style={{ display: "flex", flexDirection: "row-reverse" }}
                >
                  {decryptionError ? (
                    <p>Error </p>
                  ) : (
                    <>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={handleClick}
                        style={{
                          background: `linear-gradient(to right, ${gradientColors.join(
                            ", "
                          )})`,
                        }}
                      >
                        Update
                      </button>
                    </>
                  )}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewTaskAssignedDetails;
